/** True when the logged-in panel user is an administrator (not dispatcher). */
export const isAdminUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userType = String(user.user_type || user.role || '').toLowerCase();
    if (userType === 'admin' || userType === 'super_admin') return true;
    return user.panelType === 'admin' && userType !== 'dispatcher';
  } catch {
    return false;
  }
};
